import { Action } from '@ngrx/store';
import { ListPostOptions, Post } from '@eview/core/domain/post/post';

export enum EPostsActions {
  GetPostsData = '[Posts] Get Posts',
  GetPostSuccess = '[Posts] Get Posts success',
  GetPostFailure = '[Posts] Get Posts failure',
  GetLinkedPostsData = '[Posts] Get linked Posts',
  GetLinkedPostSuccess = '[Posts] Get linked Posts success',
  GetLinkedPostFailure = '[Posts] Get linked Posts failure',
  SubmitPostSuccess = '[Posts] Submit success',
  SubmitPostFailure = '[Posts] Submit failure'
}
export class GetPostsData implements Action {
  readonly type = EPostsActions.GetPostsData;
  constructor(public payload: ListPostOptions) { }
}

export class GetPostSuccess implements Action {
  readonly type = EPostsActions.GetPostSuccess;
  constructor(public payload: any) { }
}

export class GetPostFailure implements Action {
  readonly type = EPostsActions.GetPostFailure;
}

export class GetLinkedPostsData implements Action {
  readonly type = EPostsActions.GetLinkedPostsData;
  constructor(public payload: ListPostOptions) { }
}

export class GetLinkedPostSuccess implements Action {
  readonly type = EPostsActions.GetLinkedPostSuccess;
  constructor(public payload: any) { }
}

export class GetLinkedPostFailure implements Action {
  readonly type = EPostsActions.GetLinkedPostFailure;
}

export class SubmitPostSuccess implements Action {
  readonly type = EPostsActions.SubmitPostSuccess;
  constructor(public payload: Post) { }
}

export class SubmitPostFailure implements Action {
  readonly type = EPostsActions.SubmitPostFailure;
}

export type PostActions = GetPostsData | GetPostSuccess | GetPostFailure | GetLinkedPostsData | GetLinkedPostSuccess | GetLinkedPostFailure | SubmitPostSuccess | SubmitPostFailure;
